const fetchData = async ({Axios, url, headers,setRawData, setLoading,primerIdBodega}) => {
    try{
        const res = await Axios({
            method: 'GET',
            url,
            headers,
            params: {
                "opcion": "PRODUCTOSINGR",
                "IdBodega": primerIdBodega
            } 
        })
        setRawData(res.data.msg)
        setLoading(false)

    }catch(err){
        console.log(err)
    }
}

export {
    fetchData,
}